import type {ApiConfig} from '../../requestWrapper';
import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {ChartData, ChartType} from './types';
import type {Album} from '@deezer/next/services/types/album';
import type {Playlist} from '@deezer/next/services/types/playlist';
import type {Track} from '@deezer/next/services/types/track';
import type {Artist} from '@deezer/next/services/types/artist';

const {get} = requestWrapper;

const requests = {
	getChartData: (type: ChartType, params: any, config?: ApiConfig) => {
		return get<ChartData<Album | Playlist | Track | Artist>[]>(
			endpoints.chartData(type),
			{...config, params},
		);
	},
};

export default requests;
